'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var Flex = function (_React$Component) {
  _inherits(Flex, _React$Component);

  function Flex() {
    _classCallCheck(this, Flex);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Flex.prototype.render = function render() {
    var className = 'cf-flex';

    if (this.props.spacing) {
      className += ' cf-flex--' + this.props.spacing;
    }

    return React.createElement(
      'div',
      { className: className },
      this.props.children
    );
  };

  return Flex;
}(React.Component);

Flex.propTypes = {
  spacing: PropTypes.oneOf([false, 'thin', 'wide']).isRequired
};


module.exports = Flex;